module.exports = __webpack_public_path__ + "img/ico-minus.e3bc120f.svg";